import {
	ADD_DELETED_VARIANT,
} from "../../constants"

export const addVariationToDeletionQueue = ( variant ) => {
	return {
		type: ADD_DELETED_VARIANT,
		payload: {
			variant: variant
		}
	}
};


// WEBPACK FOOTER //
// ./src/api/variants/actions.js